import React from 'react';
import { LeafIcon } from 'lucide-react';
interface WelcomeScreenProps {
  onContinue: () => void;
  onLoginClick: () => void;
}
const WelcomeScreen: React.FC<WelcomeScreenProps> = ({
  onContinue,
  onLoginClick
}) => {
  return <div className="text-center" data-id="element-412">
      <div className="flex justify-center mb-6" data-id="element-413">
        <div className="bg-green-100 p-4 rounded-full" data-id="element-414">
          <LeafIcon size={48} className="text-green-600" data-id="element-415" />
        </div>
      </div>
      <h1 className="text-3xl font-bold mb-4 text-green-700" data-id="element-416">
        Welcome to SevenAfter
      </h1>
      <p className="mb-6 text-gray-600" data-id="element-417">
        Begin your journey to wellness and personal growth through the
        restoration of seven sacred gardens, each representing a core virtue for
        your healing path.
      </p>
      <button onClick={onContinue} className="bg-green-600 text-white py-3 px-6 rounded-lg shadow-md hover:bg-green-700 transition-colors w-full font-medium mb-4" data-id="element-418">
        Start My Journey
      </button>
      <button onClick={onLoginClick} className="text-gray-600 hover:text-gray-800 text-sm" data-id="element-419">
        Already have an account? Log in
      </button>
    </div>;
};
export default WelcomeScreen;